/**
 * Event emitter methods for BaseModal
 */

/**
 * Subscribe to modal events
 * @param {Object} modal - Modal instance
 * @param {string} event - Event name
 * @param {Function} callback - Callback function
 * @returns {Function} Unsubscribe function
 */
export function on(modal, event, callback) {
    if (!modal.events[event]) {
        modal.events[event] = [];
    }
    modal.events[event].push(callback);

    // Return unsubscribe function
    return () => off(modal, event, callback);
}

/**
 * Unsubscribe from modal events
 * @param {Object} modal - Modal instance
 * @param {string} event - Event name
 * @param {Function} callback - Callback function (optional)
 */
export function off(modal, event, callback) {
    if (!modal.events[event]) return;

    if (callback) {
        modal.events[event] = modal.events[event].filter(cb => cb !== callback);
    } else {
        // Remove all listeners for this event
        modal.events[event] = [];
    }
}

/**
 * Emit modal event
 * @param {Object} modal - Modal instance
 * @param {string} event - Event name
 * @param {*} data - Event data
 */
export function emit(modal, event, data) {
    if (!modal.events[event]) return;

    modal.events[event].forEach(callback => {
        try {
            callback(data);
        } catch (error) {
            console.error(`BaseModal: Error in event handler for "${event}"`, error);
        }
    });
}
